/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/change-picture-request',
  name: 'pictureRequest',
  component: () => import('@/views/picture/Request'),
},
{
  path: '/change-picture-history',
  name: 'pictureHistory',
  component: () => import('@/views/picture/Index'),
}
]

